import '../assets/NcActionCaption-DnG2OyWa.css';
import { a as NC_ACTIONS_IS_SEMANTIC_MENU } from "./useNcActions-BzPO2c4h.mjs";
import { createElementBlock, openBlock, toDisplayString } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcActionCaption",
  inject: {
    isInSemanticMenu: {
      from: NC_ACTIONS_IS_SEMANTIC_MENU,
      default: false
    }
  },
  props: {
    /**
     * The caption's text
     */
    name: {
      type: String,
      required: true
    }
  }
};
const _hoisted_1 = ["role"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    class: "app-navigation-caption",
    role: $options.isInSemanticMenu && "presentation"
  }, toDisplayString($props.name), 9, _hoisted_1);
}
const NcActionCaption = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-1009e96c"]]);
export {
  NcActionCaption as N
};
//# sourceMappingURL=NcActionCaption-Cgd3J8jw.mjs.map
